import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { InstantSearch, useInfiniteHits, useInstantSearch, HierarchicalMenu } from "react-instantsearch";
import { decodeFilters, isValidArray, normalizePath } from "../../Layout/Common/common";
import { SelectedFilterMobileLite } from "../algolia/selectedFilterMobile";
import { SelectedFilterLite } from "../algolia/selectedFilter";
import { FacetFilterLite } from "../algolia/facetFilter";
import { SoryByOption } from "../algolia/sortbyOption";
import { FilterContainerMobileLite } from "../algolia/filterContainerMobile";
import { SoryByOptionMobile } from "../algolia/sortbyOptionMobile";
import { SearchResultContainer } from "./searchResutlContainer";
import { axiosInstance } from "../../axios/axiosInstance";
import { GlobalContext } from "../../Context/GlobalContext";
import { CustomInfiniteHitsLite } from "../algolia/customInfiniteHits";
import { useLocation } from "react-router-dom";
import { useDevice } from "../../Context/hook/useDeviceType";
import {
  ApplyDisjunctiveFiltersFromUrl,
  FirstResultsGate,
  getInitialSortByUiState,
  GroupedConfigure,
  indexName,
  searchClient,
  UseCaptureFacets,
} from "../../Layout/Common/algoliaInstantLib";
import { Spinner } from "../../Layout/Common/spinner";
import { ManufacturerBlogContent } from "./manufacturerBlogContent";
import { ChangeViewOfProducts } from "../CategoryAlgolia/changeViewOfProducts";

export const BrandPageMain = ({ brand }) => {
  const { isGridView } = useContext(GlobalContext);
  const { device } = useDevice();
  const [sideFilterClicked, setSideFilterClicked] = useState(false);
  const [facetFilters, setFacetFilters] = useState(null);
  const [manufacturerName, setManufacturerName] = useState("");
  const [manufacturerId, setManufacturerId] = useState(0);
  const [htmlBlog, setHtmlBlog] = useState("");
  const categoryRef = useRef();
  const location = useLocation();
  const [mainCategory, setmainCategory] = useState("");
  // Page loader covering the switch from the brand grid into this page until the first products settle,
  // so the user never sees the half-built layout with the footer floating up in the middle.
  const [firstLoaded, setFirstLoaded] = useState(false);
  const handleFirstLoaded = useCallback(() => setFirstLoaded(true), []);

  useEffect(() => {
    setFacetFilters([]);
    setManufacturerName(brand.name);
    setManufacturerId(brand.id);
    setFirstLoaded(false);
  }, [brand]);

  // Safety net: never let the page loader get stuck if Algolia's status doesn't cycle as expected.
  useEffect(() => {
    const t = setTimeout(() => setFirstLoaded(true), 6000);
    return () => clearTimeout(t);
  }, [brand]);

  useEffect(() => {
    if (device && device == "desktop") {
      setSideFilterClicked(true);
    } else {
      setSideFilterClicked(false);
    }
  }, [device]);

  const categoryRefine = (val) => {
    if (categoryRef.current) {
      categoryRef.current.categoryRefine(val);
    }
  };

  return (
    <div className="brand-page-wrap">
      <InstantSearch
        key={location}
        searchClient={searchClient}
        indexName={indexName}
        initialUiState={getInitialSortByUiState(indexName)}
      >
        <GroupedConfigure filters={"prodSpecs.manufacturer:'" + brand.name + "'"} />
        <FirstResultsGate onReady={handleFirstLoaded} />
        {isValidArray(facetFilters) && <ApplyDisjunctiveFiltersFromUrl />}
        {!isValidArray(facetFilters) && <UseCaptureFacets setFacets={setFacetFilters} />}

        <section className="subcategory-section p-3">
          <div className="container-fluid container-lg">
            <SearchResultContainer search={manufacturerName} isEbook={true} mainCategory={mainCategory} />
            <ManufacturerBlogContent id={manufacturerId} />
          </div>
        </section>
        {/* <ProductCardPopularProduct /> */}
        <section className="filter-popular-section pt-2">
          <div className="container-fluid container-lg">
            <div className="row">
              <div className="col-lg-12">
                <div className="filterHead-wrapper filterHead-wrapperWeb">
                  <div className="filterbtn-left">
                    <button
                      className="btn"
                      id="searchFilter-btn"
                      onClick={() => setSideFilterClicked(!sideFilterClicked)}
                    >
                      <span className="wes-searchfilter" />
                      {sideFilterClicked ? "Hide Filters" : "Filter"}
                    </button>
                  </div>
                  <div className="filters-list">
                    <SoryByOption indexName={indexName} />
                    <ChangeViewOfProducts />
                  </div>
                </div>
                <div className="filterHead-wrapper filterHead-wrapperMob">
                  <FilterContainerMobileLite filterItems={facetFilters} ref={categoryRef} />
                  <SoryByOptionMobile />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className={`filter-product-wrapper ${sideFilterClicked ? "" : "filter-product-wrapperHide"}`}>
                  <div className={`filter-wrapper filter-wrapperWeb  mt-3 ${sideFilterClicked ? "filtersWeb" : ""}`}>
                    <div className="accordion filters-accordion accordion-flush" id="selectedfilterAccordion">
                      {isValidArray(facetFilters) && <SelectedFilterLite categoryRefine={categoryRefine} />}
                    </div>
                    <div className="accordion filters-accordion accordion-flush" id="filterAccordion">
                      {isValidArray(facetFilters) ? (
                        <div className="smooth-fade-in">
                          <FacetFilterLite
                            key={"category"}
                            attribute={"category"}
                            limit={30}
                            showMore={true}
                            sortBy={["count:desc"]}
                          />
                          {facetFilters.map((Item, index) => {
                            if (normalizePath(Item) != "manufacturer") {
                              return (
                                <FacetFilterLite
                                  key={`prodSpecs.${Item}`}
                                  attribute={`prodSpecs.${Item}`}
                                  limit={30}
                                  showMore={true}
                                />
                              );
                            }
                          })}
                        </div>
                      ) : (
                        <div className="accordion-item">loading..</div>
                      )}
                    </div>
                  </div>
                  <div
                    className={`ct-filter-product ${!sideFilterClicked ? "filterProducts" : "active"} ${
                      isGridView ? "" : "position-relative filterProducts"
                    }`}
                    style={{ width: "100%" }}
                  >
                    {isValidArray(facetFilters) && <SelectedFilterMobileLite />}

                    <div className={`row ${isGridView ? "row-spacing row-equal" : ""}`}></div>
                    <CustomInfiniteHitsLite catFilter={false} distinctFamilyMode />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </InstantSearch>
      {!firstLoaded && (
        <div className="brand-page-loader">
          <Spinner size={50} />
        </div>
      )}
    </div>
  );
};
